import { render, staticRenderFns } from "./QuantityField.vue?vue&type=template&id=011dbc08&scoped=true&"
import script from "./QuantityField.vue?vue&type=script&lang=js&"
export * from "./QuantityField.vue?vue&type=script&lang=js&"
import style0 from "./QuantityField.vue?vue&type=style&index=0&id=011dbc08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011dbc08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
